'use client'

import React, { useState } from 'react'

const Description = ({ desc }) => {

    const [showLess, setShowLess] = useState(true)

    return (
        <div>
            <p className={`text-md leading-6 text-center text-secondary ${showLess ? 'line-clamp-3' : ''}`}>
                {desc}
            </p>
            <button
                aria-label='show-more-less'
                className="text-[#eb532e] cursor-pointer text-center text-sm"
                onClick={() => setShowLess(state => !state)}
            >
                Show {showLess ? "more" : "less"}
            </button>
        </div>
    )
}

export default Description